import React, { useState } from 'react';
import { getImagePath } from '../helpers.js';
import GallerySlide from './GallerySlide.js';
import GalleryList from './GalleryList.js';
import GalleryThumb from './GalleryThumb.js';
import ITEMS from '../data.json';
import { useParams, Link } from "react-router-dom";

import DocumentMeta from 'react-document-meta';

function getItemFromPath(path){
  return ITEMS.find(i => i.path === path);
}

function GalleryItem() {

  let item = getItemFromPath(useParams().path);

  const [ active, setActive ] = useState(0);

  if (!item) {
    return <GalleryList items={ITEMS} />
  }

  const woods = [];
  item.woods.forEach(function(wood, i){
    woods.push(<div key={i} className={'wood ' + wood.toLowerCase().replace(' ', '-')}>{wood}</div>);
  });

  const meta = {
    title: `Benjamin Walker Furniture - ${item.title}`,
    description: item.description,
    meta: {
      charset: 'utf-8',
      name: {
        keywords: item.woods.join(', ')
      }
    }
  };

  return (
    <DocumentMeta {...meta}>
      <div className="gallery-item">
        <div className="left">
          <Link to=".." relative="path">&#x276E;</Link>
          <h1 className="cont">{item.title}</h1>
          <div className="cont woods">{woods}</div>
          <div className="cont dimensions">
            <table>
              <tbody>
                <tr>
                  <td>W</td>
                  <td>D</td>
                  <td>H</td>
                </tr>
                <tr>
                  <td>{item.dimentions.width}"</td>
                  <td>{item.dimentions.depth}"</td>
                  <td>{item.dimentions.height}"</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="cont gallery-thumbs">
          { item.images.map((image, i) => (
              <GalleryThumb
                key={i}
                i={i}
                image={getImagePath(image, item.image_key, "small")}
                active={i === active}
                click={() => setActive(i)}
              />
            ))}
          </div>
        </div>
        <div className="right">
          <div className="gallery-slides">
            { item.images.map((image, i) => (
              <GallerySlide
                key={i}
                image={image}
                imageKey={item.image_key}
                active={i === active}
              />
            ))}
          </div>
        </div>
      </div>
    </DocumentMeta>
  );
}

export default GalleryItem;
